import * as React from 'react';

import TypeScale from '@identity/type';

import Image from '../Image';

import { RatioContainer, Content, Text, Media } from './styles';

const SideBySide = ({
  title,
  id,
  description,
  image,
  imageRatio,
  reverseContent,
}: Props) => (
  <div>
    <Content key={id} reverseContent={reverseContent}>
      <RatioContainer imageRatio={imageRatio} />
      <Text>
        <TypeScale.H3 spacing={{ padding: 'bottom-sm' }}>{title}</TypeScale.H3>
        <TypeScale.P>{description.description}</TypeScale.P>
      </Text>
      <Media>
        <Image absolute src={image.file.url} />
      </Media>
    </Content>
  </div>
);

export default SideBySide;
